import { Result, Button } from 'antd';
import { default as React } from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import '../../styles/Stepper.css';

export const PageDone = ({ payingParticipants, emailIdentifier, amountToBePayed }) => {

    return (
        <div>
            <Result
                icon={<CheckCircleFilled />}
                title="Data Donation Completed!"
                // subTitle={payingParticipants ?
                //     'Thank you for your data donation to our research! We will contact you soon to send you your reimbursement ($' + amountToBePayed + ') through the Prolific platform.'
                    // : 'Thank you for your contribution to our research.' }
                subTitle={payingParticipants ?
                  'Thank you for your data donation to our research! We will contact you soon to send you your payment through the Prolific platform.'
                : 'Thank you for your contribution to our research.' }
            />
        </div>
    )
};

export default PageDone;